import GradientFooter from '@/components/_organisms/GradientFooter';
import FrontPinkButton from '@/components/buttons/primary/FrontPinkButton';
import Link from '@/components/Link';
import { ModuleGradientFooterFragment } from '@/graphql';
import { getSingleLink } from '@/lib/craft-utils';
import { addElementIdentifier } from '@/lib/utils';
import { FC, ReactNode } from 'react';

interface GradientFooterModuleProps extends PropsWithClassName {
  props: CraftModuleFragment<ModuleGradientFooterFragment>;
  onCTAClick?: () => void;
  ctaOverride?: (originalNode: ReactNode) => ReactNode;
}

const GradientFooterModule: FC<GradientFooterModuleProps> = ({ props, className, onCTAClick, ctaOverride }) => {
  if (Array.isArray(props)) {
    props = props[0];
  }

  if (!props) return null;

  const singleCta = getSingleLink(props.cta);

  const cta = singleCta ? (
    <Link href={singleCta.url}>
      <FrontPinkButton
        as="a"
        onClick={() => {
          if (onCTAClick) onCTAClick();
        }}
        {...addElementIdentifier('footer-cta')}
      >
        {singleCta.text}
      </FrontPinkButton>
    </Link>
  ) : null;

  return (
    <GradientFooter className={className} heading={props.heading ?? ''} cta={ctaOverride ? ctaOverride(cta) : cta} />
  );
};

export default GradientFooterModule;
